import React from 'react'

export default function Skeleton() {
  return (
    <div className='skeleton'>
      <div className='skeleton__avatar'></div>
      <div className='skeleton__author'></div>
      <div className='skeleton__details'></div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Messages/Skeleton.jsx